import {useIntl} from 'react-intl'
import {useParams} from 'react-router-dom'
import {appsAPI} from '../../../../../services/AppsService'
import {useState} from 'react'
import clsx from 'clsx'

const RoistatSettings = () => {
  const intl = useIntl()
  const {appId} = useParams()
  const {data: app} = appsAPI.useFetchAppByIdQuery(appId!)
  const [showApiKey, setShowApiKey] = useState(false)

  return (
    <>
      <div className='row mb-5'>
        <label className='col-lg-4 fw-bolder text-gray-600 text-uppercase small'>
          {intl.formatMessage({id: 'APPS.ROISTAT.PROJECT'})}
        </label>

        <div className='col-lg-8'>
          <span className='fw-bolder text-gray-800'>{app?.settings.roistat.id_project}</span>
        </div>
      </div>
      <div className='separator separator-dashed my-5'></div>
      <div className='row mb-5'>
        <label className='col-lg-4 fw-bolder text-gray-600 small text-uppercase'>
          {intl.formatMessage({id: 'APPS.ROISTAT.APIKEY'})}
        </label>

        <div className='col-lg-8 fv-row'>
          <div className='input-group d-flex align-items-center'>
            <input
              className='form-control fw-bolder text-gray-800 border-0 fs-7 p-0'
              type={showApiKey ? 'text' : 'password'}
              value={app?.settings.roistat.api_key}
              style={{borderRadius: 0}}
              readOnly
            ></input>
            <span className='border-0 p-0 me-2' style={{cursor: 'pointer'}} onClick={() => setShowApiKey(!showApiKey)}>
              <i
                className={clsx('bi text-gray-800 fs-3', {
                  'bi-eye-fill': !showApiKey,
                  'bi-eye-slash-fill': showApiKey,
                })}
              ></i>
            </span>
          </div>
        </div>
      </div>
    </>
  )
}

export {RoistatSettings}
